import {ChangeDetectorRef, EventEmitter, Injectable, OnDestroy, OnInit} from '@angular/core';
import {MatSnackBar} from '@angular/material';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import {User} from 'firebase';
import {environment} from '../../../environments/environment';

export type StorageReference = firebase.storage.Reference;
export type Auth = firebase.auth.Auth;
export type App = firebase.app.App;
export type CollectionReference = firebase.firestore.CollectionReference;
export type DocumentSnapshot = firebase.firestore.DocumentSnapshot;
export type DocumentReference = firebase.firestore.DocumentReference;

@Injectable()
export class GlobalService implements OnDestroy {
  public readonly AvailableApiVersions = ['v1', 'v2'];
  public ApiVersion: string = 'v1';

  private shouldReload: EventEmitter<void>;

  private isLoggedIn: boolean;
  private currentEmail: string;
  private app: App;

  constructor(
    private mdlSnackbarService: MatSnackBar,
  ) {
    this.shouldReload = new EventEmitter<void>();

    this.isLoggedIn = false;
    this.currentEmail = '';

    if (!firebase.apps.length) {
      this.app = firebase.initializeApp(environment.config);
      firebase.firestore().settings({timestampsInSnapshots: true});
    } else {
      this.app = firebase.apps[0];
    }


    this.GetAuth().onAuthStateChanged((user: User) => {
      if (user) {
        this.isLoggedIn = true;
        this.currentEmail = user.email;
      } else {
        this.isLoggedIn = false;
        this.currentEmail = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.app.delete();
  }

  public ShowMessage(message: string): void {
    this.mdlSnackbarService.open(message, ``, {duration: 5000});
  }

  public GetReloadTrigger(): EventEmitter<void> {
    return this.shouldReload;
  }

  public TriggerReload(): void {
    this.shouldReload.emit();
  }

  public IsUserLoggedIn(): boolean {
    return this.isLoggedIn;
  }

  public GetUserEmail(): string {
    return this.currentEmail;
  }

  public GetAuth(): Auth {
    return this.app.auth();
  }

  public GetCampusCollection(): CollectionReference {
    return this.app.firestore().collection('campus');
  }

  public GetCoverBaseRef(): StorageReference {
    return this.app.storage().ref(`/${this.ApiVersion}/prod/covers`);
  }

  public GetAssetBundleBaseRef(): StorageReference {
    return this.app.storage().ref(`/${this.ApiVersion}/prod/assetbundles`);
  }
}
